import { EventMessage } from '@/common/analytics/gtm//types';
import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';
import { mapMessageToProduct } from '@/common/analytics/gtm/mappers';

export const trackUAProductClick = (message: EventMessage) => {
  if (message.metadata.messageSendingDisabled) return;
  const {
    metadata: { gaPageName, listingType, listingFunction },
  } = message;
  createTrackingEvent({
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: { list: `PT:${gaPageName}|LT:${listingType}|LF:${listingFunction}` },
        products: [mapMessageToProduct(message)],
      },
    },
  });
};
